import React, { createContext, useContext, useState } from "react";

const TabListContext = createContext({});

export const TabListContextProvider = ({ children }) => {
  const [programTabList, setProgramTabList] = useState("");
  const [careplanTabList, setCareplanTabList] = useState("");
  const [groupTabList, setGroupTabList] = useState("");
  return (
    <TabListContext.Provider
      value={{
        programTabList,
        setProgramTabList,
        careplanTabList,
        setCareplanTabList,
        groupTabList,
        setGroupTabList
      }}
    >
      {children}
    </TabListContext.Provider>
  );
};

// Create a custom hook to easily access the context values
export const useTabList = () => {
  return useContext(TabListContext);
};
